// SpacetimeDB connection settings and guest identities. Supabase sign-in lives in supabaseLogin.ts.
export interface SpacetimeOptions {
  uri: string;
  database: string;
  /** SpacetimeDB guest identities, for local development worlds without sign-in (players' guests are Supabase's). */
  guests: boolean;
}

/** The claims of a JWT (not checked here: the world checks the token). */
export function claimsOf(token: string): Record<string, unknown> {
  try {
    const part = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(part + '='.repeat((4 - (part.length % 4)) % 4))) as Record<string, unknown>;
  } catch { return {}; }
}

/** A name for an account's token, for the screens (the world keeps its own). */
export function accountName(token: string | undefined): string {
  if (!token) return 'guest';
  const c = claimsOf(token);
  for (const k of ['preferred_username', 'name', 'nickname', 'email']) if (typeof c[k] === 'string' && c[k]) return c[k] as string;
  return 'guest';
}

const guestKey = (o: SpacetimeOptions) => `ashenheart:stdb-guest:${o.uri}/${o.database}`;

export function guestToken(o: SpacetimeOptions): string | undefined {
  try { return localStorage.getItem(guestKey(o)) ?? undefined; } catch { return undefined; }
}

export function keepGuestToken(o: SpacetimeOptions, token: string): void {
  try { localStorage.setItem(guestKey(o), token); } catch { /* private window: a new guest each time */ }
}
